import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import './style.scss';
import ResourcesList from 'components/ResourcesList';
import Resource from 'components/ResourcesList/Resource';
import ResourcesListLoading from 'components/ResourcesListLoading';
import ChatResourcesPageSelector from './ChatResourcesPageSelector';
import * as actions from 'actions';
import { getChatResources, getChatPaging } from 'selectors';
import { ChatResourceShape } from 'entities';

class ChatResources extends Component {

  componentDidMount() {
    this.props.onFetchCurrentPage();
  }

  render() {
    return (
      <section className="content-wrapper has-background">
        <div className="wrapper-small">
          <h1>{__('members.chat.resources.title')}</h1>

          {(() => {
            if(this.props.chatResources.length > 0) {
              return (
                <ResourcesList showsAll>
                  {this.props.chatResources.map(chatResource => {
                    const key = chatResource.sentAt + '_' + chatResource.data.url;

                    return (
                      <Resource
                        key={key}
                        title={chatResource.metadata.title}
                        authorName={chatResource.sender}
                        since={moment(chatResource.sentAt).fromNow()}
                        isWebsite
                        url={chatResource.data.url}
                        />
                    );
                  })}
                </ResourcesList>
              );
            }
            else if(this.props.isFetching) {
              return <ResourcesListLoading />;
            }
          })()}
        </div>

        {(() => {
          if(this.props.showsPageSelector) {
            return <ChatResourcesPageSelector />;
          }
        })()}
      </section>
    );
  }
}

ChatResources.propTypes = {
  pagesCount: PropTypes.number,
  isFetching: PropTypes.bool,
  chatResources: PropTypes.arrayOf(ChatResourceShape),
  page: PropTypes.number,
  onFetchCurrentPage: PropTypes.func,
  showsPageSelector: PropTypes.bool
};

const mapStateToProps = state => {
  const { page, isFetching, pagesCount } = getChatPaging(state, 'chatResources');

	return {
    chatResources: getChatResources(state, { page }),
    isFetching,
    pagesCount,
    page,
    showsPageSelector: pagesCount > 1
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchCurrentPage: () => {
      dispatch(actions.chatResourcesFetch());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatResources);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatResources/index.js
 **/